import {ANNOTATION_VIDEO_DISPLAY, ANNOTATION_PARENT, VIDEO_PLAYING_MODE, ANNOTATION_LOCATION} from './GlobalConstants';
import * as THREE from 'three';

export const ANNOTATION_CONTACT_TEXT = '';
export const CONTACT_URL = 'WEBSITE';
export const YOUTUBE = 'YOUTUBE';
export const INSTAGRAM = 'INSTAGRAM';
export const SPOTIFY = 'SPOTIFY';
export const TWITTER = 'TWITTER';
export const TIKTOK = 'TIKTOK';
export const IMDB = 'IMDB';
export const FACEBOOK = 'FACEBOOK';
export const ENQUIRE_EMAIL = 'ENQUIRE';
export const LINKED_IN = 'LINKEDIN';
export const HAS_MEDIA_CAROUSEL_LINK = 'MORE';
export const SEND_TO_EMAIL = 'SEND TO';

// export const CANTALOUPE_IMAGE_SERVER = "https://iiif.v21artspace.com/iiif/2/art-forward%2Fwaiting-for-time%2F";
export const CANTALOUPE_IMAGE_SERVER = "https://iiif.v21artspace.com/iiif/2/beirut-american-uni%2Fmahmoud-Kahil-Award-2021%2F";


export const ANNOTATION_TEXT_ALIGNMENT = "justify";
export const ANNOTATION_TEXT_LINE_HEIGHT = "1.5";
// export const GALLERY_LINK_LABEL = "WORKS";
export const GALLERY_LINK_LABEL = `<img src='/assets/languages/iconfinder_uk.png'>`;



const AnnotationsDB = [

    /* Entrance Text */
    {
        paintingId: 'INTROANNOT01',
        videoId: null,
        videoURL: null,
        displayMesh: 'N',
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['INTROANNOT01AR', 'INTROANNOT01UK'],
    },
    {
        paintingId: 'INTROANNOT01AR',
        videoId: null,
        videoURL: null,
        annotationTextAlignment: 'right',
        isMediaUsed: 'N',
        headerText: `<h5>جــــــــائزة محمــــــــــــــــود كحيــــــــل</h5>`,
        bodyText: `<span dir="rtl">يهدف برنامج جائزة محمود كحيل إلى تعزيز الشرائط المصورة والكاريكاتير السياسي والرسوم التعبيرية في العالم العربي من خلال إبراز مواهب وإنجازات رسامي الشرائط والقصص المصورة والكاريكاتير في المنطقة. تم إنشاء برنامج الجائزة في العام 2014، تحت مبادرة معتز ورادا الصواف للشرائط المصورة العربية في الجامعة الأميركية في بيروت، لتكريم وتخليد تراث الراحل محمود كحيل، الذي كان واحدًا من أبرز رسامي الكاريكاتير في العالم العربي، وكان خريجًا من الجامعة الأميركية في بيروت. وتطلق دعوة مفتوحة سنويًا لترشيح أعمال في مختلف الفئات للجائزة. ويتم تقييم الأعمال المرشحة والتصويت عليها من قبل لجنة تحكيم مختارة يُعلن عنها خلال مؤتمر صحفي لإطلاق الجائزة، ويتم الإعلان عن الفائزين وتكريمهم في حفل توزيع الجوائز السنوي.<br><br><b>مبادرة معتز ورادا الصّــــــــــــــــــواف للشرائط المصوّرة العربية</b><br>إن مبادرة معتز ورادا الصواف للشرائط المصوّرة العربية هي هيئة أكاديمية في الجامعة الأمريكية في بيروت، تهدف إلى تعزيز البحوث المتعددة التخصصات عن الشرائط المصورة العربية، ودعمها. وتهدف أيضًا إلى تشجيع إنتاجها ودراستها وتعليمها، وتكوين مخزن لمنشورات الشرائط المصورة العربية. والأمل معقود على المبادرة لتطويرها إلى مركز للشرائط المصورة العربية لدراسة هذا التراث الثقافي العربي لتكون عبارة عن منصة لدراسة هذا الفن وتعليمه. إن هذه المبادرة، لم تصبح ممكنة إلا بفضل التبرع السخي من السيد معتز والسيدة رادا الصواف، تبني على الموارد الغنية للجامعة، بما في ذلك هيئتها التعليمية المتنوعة من الباحثين والأساتذة في مختلف الاختصاصات، وعلى سمعتها المتميزة في المنطقة وعلى مكتبتها المتفوقة في الأرشفة والحفظ الرقمي، من ناحية التجهيزات والإمكانات البشرية والإلكترونية. وتستضيف هذه المبادرة بالإضافة الى برنامج جائزة محمود كحيل واحتفاله السنوي، ندوة أكاديمية سنوية حول الشرائط المصورة لتعزيزها وتطويرها وتشجيع نشر الدراسات الأبحاث والدراسات الفنية عنها. كما تنظم المبادرة معارض وتقدم دروس ومحترفات عن الشرائط المصورة خلال السنة بالإضافة الى دعمها مهرجانات محلية ودولية.</span>`,

    },
    {
        paintingId: 'INTROANNOT01UK',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: '<h5>The Mahmoud Kahil Award </h5>',
        bodyText: `The Mahmoud Kahil Award is an award program under the Mu’taz & Rada Sawwaf Arabic Comics Initiative at the American University of Beirut that aims to promote comics, editorial cartoons and illustration in the Arab world through the recognition of the rich talent and creative achievement of comics artists, cartoonists and illustrators in the region. This program was established in 2014 upon the initiative of Mr. Mu’taz Sawwaf to honor and perpetuate the legacy of the late Mahmoud Kahil, one of the leading cartoonists and caricaturists of the Arab World, and a former AUB graduate. An open call to submit artworks in the various categories of editorial cartoons, Comics & illustration is launched annually. A select panel of jury members are invited to view the work and select the final winners, who are celebrated during the annual award ceremony.<br><br><b>The Mu’taz & Rada Sawwaf Arab Comics Initiative</b><br>The Mu’taz & Rada Sawwaf Arabic Comics Initiative is an academic body for the study of Arabic Comics at the American University of Beirut. It aims to elevate and facilitate the interdisciplinary research of Arabic comics, promote the production, scholarship and teaching of comics, and develop and maintain a repository of Arabic comics literature. The initiative is hoped to eventually develop into an Arabic Comics Center that would act as a hub for the study of this Arabic cultural heritage and a platform for the interdisciplinary inquiry and specialized teaching of this art form. This initiative, made possible with the generous donation of Mr. Mu’taz and Mrs. Rada Sawwaf, builds on AUB’s rich resources including its diverse body of scholars and professors from various disciplines, its reputation of excellence in the region and its professionally equipped and staffed library with its archiving and digital curating services. In addition to the Mahmoud Kahil Award, the initiative organizes an annual symposium on comics to promote and advance the field and to encourage the publication of scholarly and artistic works on comics. The initiative also offers courses, workshops and organizes exhibitions pertaining to comics throughout the year, as well as supporting various local and regional festivals.`,

    },
    /* Entrance Text */

    /* Wall 1: Editorial Cartoons */
    {
        paintingId: 'CAR0103',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['CAR0103AR', 'CAR0103EN'],
        annotation_location: ANNOTATION_LOCATION.BOTTOM_RIGHT,
    },
    {
        paintingId: 'CAR0103AR',
        videoId: null,
        videoURL: null,
        annotationTextAlignment: 'right',
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CAR0103a.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CAR0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CAR0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CAR0103.jpg/info.json`,],
        headerText: '<h5>موفق قات، سوريا</h5>',
        bodyText: `<span dir="rtl"><i>الفائز في فئة الكاريكاتير السياسي </i><br><br>ولد موفق قات في دمشق في عام 1955. رسام كاريكاتير وصانع أفلام رسوم متحركة، يعمل حاليًا لحسابه في مجال الكاريكاتير السياسي في عدة صحف ومجلات عربية. نالت أعماله مكافآت عدة في العديد من المهرجانات والمسابقات السينمائية الدولية والمحلية بما في ذلك جائزة الصحافة العربية لعام 2016. درّس فنون الرسوم المتحركة في جامعات سورية بينها الجامعة الدولية للعلوم والتكنولوجيا، وجامعة القلمون، والمعهد العالي للفنون المسرحية. قام برسم عدد من الكتب والكتيبات والملصقات لمنظمة اليونيسف، وأشرف على العديد من ورش العمل لبرنامج الأمم المتحدة الإنمائي في دمشق. كما كان عضواً في عدة لجان تحكيم في مباريات الكاريكاتير ومهرجانات الأفلام. حائز على ماجستير في الفنون من المعهد العالي للسينما (VGIK) في موسكو.</span>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    {
        paintingId: 'CAR0103EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CAR0103a.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CAR0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CAR0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CAR0103.jpg/info.json`,],
        headerText: '<h5>Mwafaq Katt, Syria</h5>',
        bodyText: `<i>Editorial Cartoon Winner</i><br><br>Born in Damascus in 1955, Mwafaq Katt is a cartoonist and animation filmmaker. He currently freelances editorial cartoons for several Arabic newspapers and magazines. His work was awarded in numerous international and local film festivals and competitions, including the Arab Journalism Award in 2016. Mwafaq taught animation arts in several Syrian universities, including the International University for Science and Technology, the University of Kalamoon, and the Higher Institute for Dramatic Arts. He illustrated various books, brochures, and posters for the UNICEF and facilitated many UNDP workshops in Damascus. He has served as a jury member for many cartoon contests and film festivals. He holds a Masters degree in Arts from the Higher Institute of Cinema (VGIK), Moscow.`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    /* Wall 1: Editorial Cartoons */


    /* Wall 2: Graphic Novels */
    {
        paintingId: 'NOV0102',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['NOV0102AR', 'NOV0102UK'],
    },
    {
        paintingId: 'NOV0102AR',
        videoId: null,
        videoURL: null,
        annotationTextAlignment: 'right',
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}NOV0102a.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}NOV0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}NOV0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}NOV0103.jpg/info.json`],
        headerText: '<h5>مي كريّم، مصر</h5>',
        bodyText: `<span dir="rtl"><i>الفائزة في فئة الروايات التصويرية</i><br><br>ولدت مي كريّم في الإسكندرية في 5 أيار 1980 وتخرجت من كلية الفنون الجميلة، قسم الرسم في 2003. بدأت مسيرتها المهنية في عام 2013 في مجال الشرائط المصورة. ونشرت في 2015 أولى رواياتها التصويرية بعنوان "حين تخلت الآلهة عن كفافيس" التي اختيرت واحدة من أفضل ثلاث روايات تصويرية في مهرجان القاهرة الدولي للشرائط المصورة. في عام 2017، فازت بأفضل قصة قصيرة "Pour Femme" في المهرجان نفسه. نشرت في 2018 كتابًا للأطفال وكتابًا تثقيفيًا عن دار نشر "أفوريسما" في برلين. وفي عام 2020، نشرت روايتها التصويرية الثانية بعنوان "القضيّة (43) اللَبانِ" عن دار نشر "كُتُبنا".</span>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    {
        paintingId: 'NOV0102UK',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}NOV0102a.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}NOV0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}NOV0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}NOV0103.jpg/info.json`],
        headerText: '<h5>Mai Koraiem, Egypt</h5>',
        bodyText: `<i>Graphic Novels Winner</i><br><br>Born in Alexandria on May 5, 1980, Mai Koraiem graduated from the Faculty of Fine Arts, Painting Department, in 2003. In 2013, she started her comics career. In 2015, she published her first graphic novel, entitled "When the Gods gave up on Kavafis," selected one of the best three graphic novels at the Cairo Comix Festival. In 2017, she won the best short story, "Pour Femme," at the Cairo Comix Festival. She published in 2018 a children's book and educational book with "Aphorisma" Publishing House in Berlin. In 2020, Mai published her second graphic novel entitled "Case 43 Labban" by "Kotobna" Publishing House.`,
        // urlLink1Label: "",
        // urlLink1: '',
    },

    {
        paintingId: 'NOV0201',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['NOV0201AR', 'NOV0201UK'],
    },
    {
        paintingId: 'NOV0201AR',
        videoId: null,
        videoURL: null,
        annotationTextAlignment: 'right',
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}NOV0201.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}NOV0202.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}NOV0201a.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}NOV0201b.jpg/info.json`],
        headerText: `<h5>حازم كمال، مصر</h5>`,
        bodyText: `<span dir="rtl"><i>قنديل الجو، دار الكرمة ، مصر، ٢٠٢٠</i></span>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    {
        paintingId: 'NOV0201UK',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}NOV0201.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}NOV0202.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}NOV0201a.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}NOV0201b.jpg/info.json`],
        headerText: '<h5>Hazem Kamal, Egypt</h5>',
        bodyText: `<i>Jelly Bird, Al Karma Publishing House, Egypt, 2020</i>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },

    {
        paintingId: 'NOV0302',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['NOV0302AR', 'NOV0302UK'],
    },
    {
        paintingId: 'NOV0302AR',
        videoId: null,
        videoURL: null,
        annotationTextAlignment: 'right',
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}NOV0301.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}NOV0302.jpg/info.json`],
        headerText: '<h5>نومي حنين، لبنان</h5>',
        bodyText: `<span dir="rtl"><i>أهمية شعر الأنف، سارباكان، فرنسا، ٢٠٢٠</i></span>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    {
        paintingId: 'NOV0302UK',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}NOV0301.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}NOV0302.jpg/info.json`],
        headerText: '<h5>Noemie Honein, Lebanon</h5>',
        bodyText: `<i>De l'importance du poil de nez, Sarbacane, France, 2020</i>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },

    {
        paintingId: 'NOV0401',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['NOV0401AR', 'NOV0401UK'],
    },
    {
        paintingId: 'NOV0401AR',
        videoId: null,
        videoURL: null,
        annotationTextAlignment: 'right',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NOV0401.jpg/info.json`,
        headerText: '<h5>دينا محمد، مصر</h5>',
        bodyText: `<span dir="rtl"><i>شبيك لبيك ٢،مركز المحروسة للنشر و الخدمات الصحفية و المعلومات ، مصر، ٢٠١٩</i></span>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    {
        paintingId: 'NOV0401UK',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NOV0401.jpg/info.json`,
        headerText: '<h5>Deena Mohamed, Egypt</h5>',
        bodyText: `<i>Shubeik Lubeik 2, ElMahrousa Center for publishing, press services and information, Egypt</i>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },

    {
        paintingId: 'NOV0501',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['NOV0501AR', 'NOV0501UK'],
        annotation_location: ANNOTATION_LOCATION.CENTER_LEFT,
    },
    {
        paintingId: 'NOV0501AR',
        videoId: null,
        videoURL: null,
        annotationTextAlignment: 'right',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NOV0501.jpg/info.json`,
        headerText: '<h5>محمود شلتوت، مصر</h5>',
        bodyText: `<span dir="rtl"><i>كورونا بالبشاميل، نشر ذاتي (منصة تاباس للشرائط المصورة)، مصر، ٢٠٢٠</i></span>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    {
        paintingId: 'NOV0501UK',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NOV0501.jpg/info.json`,
        headerText: '<h5>Mahmoud Shaltout, Egypt</h5>',
        bodyText: `<i>Corona with Béchamel, Self-Published (Tapas Comics Platform), Egypt, 2020</i>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },

    {
        paintingId: 'NOV0601',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['NOV0601AR', 'NOV0601UK'],
    },
    {
        paintingId: 'NOV0601AR',
        videoId: null,
        videoURL: null,
        annotationTextAlignment: 'right',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NOV0601.jpg/info.json`,
        headerText: `<h5>ميجو، مصر</h5>`,
        bodyText: `<span dir="rtl"><i>هند نافع/ ثائرة مصرية، جامعة ولاية المكسيك الجديدة، الولايات المتحدة الأمريكية، ٢٠١٩ </i></span>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    {
        paintingId: 'NOV0601UK',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NOV0601.jpg/info.json`,
        headerText: '<h5>Migo, Egypt</h5>',
        bodyText: '<i>Hind Nafea/ A Revolutionary Egyptian Woman, New Mexico State University, USA, 2019</i>',
        // urlLink1Label: "",
        // urlLink1: '',
    },


    {
        paintingId: 'NOV0701',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['NOV0701AR', 'NOV0701UK'],
    },
    {
        paintingId: 'NOV0701AR',
        videoId: null,
        videoURL: null,
        annotationTextAlignment: 'right',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NOV0701.jpg/info.json`,
        headerText: '<h5>رافايل معكرون، لبنان</h5>',
        bodyText: `<span dir="rtl"><i>الأرضيون،دار نشرفوبورغ، فرنسا، ٢٠٢٠</i></span>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    {
        paintingId: 'NOV0701UK',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NOV0701.jpg/info.json`,
        headerText: '<h5>Raphaelle Macaron, Lebanon</h5>',
        bodyText: `<i>Les Terrestres, Editions Du Faubourg, France, 2020</i>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    /* Wall 2: Graphic Novels */


    /* Wall 3: Comics */
    {
        paintingId: 'COM0103',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['COM0102AR', 'COM0102UK'],
        annotation_location: ANNOTATION_LOCATION.TOP_RIGHT,
    },
    {
        paintingId: 'COM0102AR',
        videoId: null,
        videoURL: null,
        annotationTextAlignment: 'right',
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}COM0102a.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}COM0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}COM0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}COM0103.jpg/info.json`],
        headerText: '<h5>ميجو, مصر</h5>',
        bodyText: `<span dir="rtl"><i>الفائز في فئة الشرائط المصورة<br>ملبن سادة ،توك توك، مصر، ٢٠٢٠</i><br><br>ولد ميجو محمد في عام 1988 وهو فنان ومؤلف شرائط مصورة مصري. درس السينما في الولايات المتحدة الأمريكية، وعمل في العديد من المجلات مثل "توك توك"، و"السمندل"، و"مخبر 619" و"كلمات بلا حدود". فنه حاضر في المعارض الفنية الدولية وهو مدير فني للعديد من الكتب والمجلات. في 2007 أدار فيلم رسوم متحركة قصير لـمحطة بي.بي.سي. العربية "SHAME". حاز في 2015 على جائزة أفضل قصة قصيرة في مهرجان القاهرة الدولي للشرائط المصورة.</span>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    {
        paintingId: 'COM0102UK',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}COM0102a.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}COM0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}COM0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}COM0103.jpg/info.json`],
        headerText: '<h5>Migo, Egypt</h5>',
        bodyText: `<i>Comics Winner<br> Plain Candy, TokTok, Egypt, 2020</i><br><br>Born in 1988, Migo Mohamad is an Egyptian Comics artist and author. He studied film in the United States. He worked in many magazines such as TokTok, Samandal, Lab619, and Words Without Borders. His art showed in many international art exhibitions. Migo is an art director for several books and magazines. In 2017, he directed a short animation film for BBC Arabic, "Shame," and received the Best Short Story award at the Cairo Comix International Festival 2015.`,
        // urlLink1Label: "",
        // urlLink1: '',
    },

    {
        paintingId: 'COM0201',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['COM0201AR', 'COM0201UK'],
    },
    {
        paintingId: 'COM0201AR',
        videoId: null,
        videoURL: null,
        annotationTextAlignment: 'right',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}COM0201.jpg/info.json`,
        headerText: '<h5>إيليا طويل، لبنان</h5>',
        bodyText: `<span dir="rtl"><i>نوستالجيا ،مجلة رحلة، لبنان، ٢٠٢٠</i></span>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    {
        paintingId: 'COM0201UK',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}COM0201.jpg/info.json`,
        headerText: '<h5>Elia Tawil, Lebanon</h5>',
        bodyText: '<i>Nostalgia, Rehla Magazine, Lebanon, 2020</i>',
        // urlLink1Label: "",
        // urlLink1: '',
    },

    {
        paintingId: 'COM0202',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['COM0202AR', 'COM0202UK'],
    },
    {
        paintingId: 'COM0202AR',
        videoId: null,
        videoURL: null,
        annotationTextAlignment: 'right',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}COM0202.jpg/info.json`,
        headerText: '<h5>إيليا طويل، لبنان</h5>',
        bodyText: `<span dir="rtl"><i>أيو دودو ،مجلة رحلة، لبنان، ٢٠٢٠</i></span>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    {
        paintingId: 'COM0202UK',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}COM0202.jpg/info.json`,
        headerText: '<h5>Elia Tawil, Lebanon</h5>',
        bodyText: `<i>Abu Doodoo, Rehla Magazine, Lebanon, 2020</i>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },

    {
        paintingId: 'COM0301',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['COM0301AR', 'COM0301UK'],
    },
    {
        paintingId: 'COM0301AR',
        videoId: null,
        videoURL: null,
        annotationTextAlignment: 'right',
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}COM0301.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}COM0302.jpg/info.json`],
        headerText: '<h5>غدي غصن، لبنان</h5>',
        bodyText: `<span dir="rtl"><i>زعاميمو، الحدود، الأردن، ٢٠٢٠</i></span>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    {
        paintingId: 'COM0301UK',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}COM0301.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}COM0302.jpg/info.json`],
        headerText: '<h5>Ghadi Ghosn, Lebanon</h5>',
        bodyText: `<i>Their Leaders, Al Hudood, Jordan, 2020</i>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },

    {
        paintingId: 'COM0401',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['COM0401AR', 'COM0401UK'],
    },
    {
        paintingId: 'COM0401AR',
        videoId: null,
        videoURL: null,
        annotationTextAlignment: 'right',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}COM0401.jpg/info.json`,
        headerText: '<h5>كارين كيروز، لبنان</h5>',
        bodyText: `<span dir="rtl"><i>قابيل، سمندل، فرنسا، ٢٠٢٠</i></span>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    {
        paintingId: 'COM0401UK',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}COM0401.jpg/info.json`,
        headerText: '<h5>Karen Keyrouz, Lebanon</h5>',
        bodyText: `<i>Abel, Samandal Comics, France, 2020</i>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },

    {
        paintingId: 'COM0501',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['COM0501AR', 'COM0501UK'],
        annotation_location: ANNOTATION_LOCATION.TOP_CENTER,
    },
    {
        paintingId: 'COM0501AR',
        videoId: null,
        videoURL: null,
        annotationTextAlignment: 'right',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}COM0501.jpg/info.json`,
        headerText: '<h5>نهى حبيب، تونس</h5>',
        bodyText: `<span dir="rtl"><i>شيفت ، شيفت ، تونس، ٢٠١٩</i></span>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    {
        paintingId: 'COM0501UK',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}COM0501.jpg/info.json`,
        headerText: '<h5>Noha Habaeib, Tunisia</h5>',
        bodyText: `<i>Shift, Shift, Tunisia, 2019</i>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },

    {
        paintingId: 'COM0601',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['COM0601AR', 'COM0601UK'],
        annotation_location: ANNOTATION_LOCATION.TOP_CENTER,
    },
    {
        paintingId: 'COM0601AR',
        videoId: null,
        videoURL: null,
        annotationTextAlignment: 'right',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}COM0601.jpg/info.json`,
        headerText: '<h5>عظيم الغصين،فلسطين</h5>',
        bodyText: `<span dir="rtl"><i>وقت الذروة، مؤسسة الشارقة للفنون ، الإمارات العربية المتحدة ، ٢٠١٩</i></span>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    {
        paintingId: 'COM0601UK',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}COM0601.jpg/info.json`,
        headerText: '<h5>Azim Al Ghussein, Palestine</h5>',
        bodyText: `<span dir="rtl"><i>PrimeTime, Sharjah Art Foundation, United Arab Emirates, 2019</i></span>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },

    {
        paintingId: 'COM0701',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['COM0701AR', 'COM0701UK'],
    },
    {
        paintingId: 'COM0701AR',
        videoId: null,
        videoURL: null,
        annotationTextAlignment: 'right',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}COM0701.jpg/info.json`,
        headerText: '<h5>رواند عيسى، لبنان</h5>',
        bodyText: `<span dir="rtl"><i>الصداع النصفي، مواقع التواصل الاجتماعي ،٢٠٢٠</i></span>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    {
        paintingId: 'COM0701UK',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}COM0701.jpg/info.json`,
        headerText: '<h5>Rawand Issa, Lebanon</h5>',
        bodyText: `<i>Migraines, Social Media 2020</i>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },

    {
        paintingId: 'COM0801',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['COM0801AR', 'COM0801UK'],
        annotation_location: ANNOTATION_LOCATION.TOP_CENTER,
    },
    {
        paintingId: 'COM0801AR',
        videoId: null,
        videoURL: null,
        annotationTextAlignment: 'right',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}COM0801.jpg/info.json`,
        headerText: '<h5>مزينة والشيباني، الإمارات العربية المتحدة </h5>',
        bodyText:`<span dir="rtl"><i>خالد مزينة ومحمد الشيباني<br>السبت، سمندل العدد ٦، لبنان، ٢٠١٩</i></span>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    {
        paintingId: 'COM0801UK',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}COM0801.jpg/info.json`,
        headerText: '<h5>Mezaina & Shaibani, UAE</h5>',
        bodyText: `<i>Khalid Mezaina and Mohammed Al Shaibani<br>Saturdaze, Samandal Issue 6, Lebanon, 2019</i>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    /* Wall 3: Comics */


    /* Wall 4: Graphic Illustartion */
    {
        paintingId: 'ILL0103',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['ILL0103AR', 'ILL0103UK'],
        annotation_location: ANNOTATION_LOCATION.BOTTOM_RIGHT,
    },
    {
        paintingId: 'ILL0103AR',
        videoId: null,
        videoURL: null,
        annotationTextAlignment: 'right',
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}ILL0103a.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ILL0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ILL0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ILL0103.jpg/info.json`],
        headerText: '<h5>ميشيل جبارين، فلسطين</h5>',
        bodyText: `<span dir="rtl"><i>الفائز في فئة الرسوم التصويرية والتعبيرية<br>المستهلك الخلوق، هاينرش بول شتيفتنج، كندا، ٢٠٢٠</i><br><br>ميشيل جبارين مصمم/فنان جماعي وتجريبي يعمل على تنمية منهجيات التعبير الفني لضمان التواصل الأكثر كفاءة وفعالية مع الجمهور من خلال تجربة التكامل بين مختلف المدارس الفنية، على مستوى التصوير المرئي والأداء على حد سواء. بعد تخرجه مع درجة البكالوريوس في الهندسة المعمارية في 2016، كرّس شغفه نحو الفن للتأثير على الممارسات الاجتماعية والفردية باستخدام قوة الصورة في الاتصال المرئي والتوجيه السلوكي ويعمل حاليًا على دمج الفن في ريادة الأعمال والتصوير والشرائط المصورة وإنتاج الوسائط المتعددة والممارسات المسرحية والفن السلوكي في التصميم المعماري والداخلي.</span>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    {
        paintingId: 'ILL0103UK',
        videoId: null,
        videoURL: null,
        // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}ILL0103.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}ILL0103a.jpg/info.json`],
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}ILL0103a.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ILL0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ILL0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ILL0103.jpg/info.json`],
        headerText: '<h5>Michael Jabareen, Palestine</h5>',
        bodyText: `<i>Graphic Illustration Winner<br>Ethical Consumer, Heinrich Böll Stiftung, Canada, 2020</i><br><br>Michael J. is a collective, experimental designer/artist who works on developing art expression methodologies to ensure the most efficient and effective connection with the audience by experimenting with integrating different schools of art, both visual and performance. After graduating with a Bachelor's degree in Architectural Engineering in 2016, Michael dedicated his passion towards art to influence social and individual practices using the power of the image in visual communication and behavioral guidance. At the moment, he works on integrating art in business entrepreneurship, illustration, comics, multimedia production, theatrical practices, and behavioral art in architectural and interior design.`,
        // urlLink1Label: "",
        // urlLink1: '',
    },

    {
        paintingId: 'ILL0201',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['ILL0201AR', 'ILL0201UK'],
    },
    {
        paintingId: 'ILL0201AR',
        videoId: null,
        videoURL: null,
        annotationTextAlignment: 'right',
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}ILL0201.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ILL0202.jpg/info.json`],
        headerText: '<h5>عثمان سلمي، تونس</h5>',
        bodyText: `<span dir="rtl"><i>أبجدية كوفيد في تونس (سلسلة من الرسوم التوضيحية)، المفكرة القانونية في تونس و ميدان، تونس، ٢٠٢٠</i></span>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    {
        paintingId: 'ILL0201UK',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}ILL0201.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ILL0202.jpg/info.json`],
        headerText: '<h5>Othman Selmi, Tunisia</h5>',
        bodyText: `<i>ABC's of Covid-19 in Tunisia (series of illustrations), Legal Agenda Tunisia & Meedan, Tunisia, 2020</i>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },

    {
        paintingId: 'ILL0301',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['ILL0301AR', 'ILL0301UK'],
    },
    {
        paintingId: 'ILL0301AR',
        videoId: null,
        videoURL: null,
        annotationTextAlignment: 'right',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ILL0301.jpg/info.json`,
        headerText: '<h5>زينب بن حوالة، تونس</h5>',
        bodyText: `<span dir="rtl"><i>الخردوات، سنترال، تونس، ٢٠٢٠</i></span>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    {
        paintingId: 'ILL0301UK',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ILL0301.jpg/info.json`,
        headerText: '<h5>Zeineb Ben Haouala, Tunisia</h5>',
        bodyText: `<i>Mercerie, Central, Tunisia, 2020</i>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },

    {
        paintingId: 'ILL0302',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['ILL0302AR', 'ILL0302UK'],
    },
    {
        paintingId: 'ILL0302AR',
        videoId: null,
        videoURL: null,
        annotationTextAlignment: 'right',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ILL0302.jpg/info.json`,
        headerText: '<h5>زينب بن حوالة، تونس</h5>',
        bodyText: `<span dir="rtl"><i>القط لا يهتم، سنترال، تونس، ٢٠٢٠</i></span>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    {
        paintingId: 'ILL0302UK',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ILL0302.jpg/info.json`,
        headerText: '<h5>Zeineb Ben Haouala, Tunisia</h5>',
        bodyText: `<i>Le Chat S'en Fout, Central, Tunisia, 2020</i>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },

    {
        paintingId: 'ILL0401',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['ILL0401AR', 'ILL0401UK'],
        annotation_location: ANNOTATION_LOCATION.BOTTOM_RIGHT,
        annotation_location_vert_offset: 0.05,
        annotation_location_horiz_offset: -0.01,
    },
    {
        paintingId: 'ILL0401AR',
        videoId: null,
        videoURL: null,
        annotationTextAlignment: 'right',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ILL0401.jpg/info.json`,
        headerText: '<h5>ظريفة حيدر مارين،لبنان</h5>',
        bodyText: `<span dir="rtl"><i>الثورة اللبنانية: النساء،مجلة جي أف آي لحقوق الإنسان، المملكة المتحدة، ٢٠٢٠</i></span>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    {
        paintingId: 'ILL0401UK',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ILL0401.jpg/info.json`,
        headerText: '<h5>Zarifi Haidar Marin, Lebanon</h5>',
        bodyText: `<i>Lebanese Revolution: The Women, JFA Human Rights Journal, United Kingdom, 2020</i>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },

    {
        paintingId: 'ILL0501',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['ILL0501AR', 'ILL0501UK'],
        annotation_location: ANNOTATION_LOCATION.TOP_LEFT,
        annotation_location_vert_offset: 0.05,
    },
    {
        paintingId: 'ILL0501AR',
        videoId: null,
        videoURL: null,
        annotationTextAlignment: 'right',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ILL0501.jpg/info.json`,
        headerText: '<h5>سنية بن سالم،تونس</h5>',
        bodyText: `<span dir="rtl"><i>سكر وليمون، أرتفرنس، فرنسا، ٢٠٢٠</i></span>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    {
        paintingId: 'ILL0501UK',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ILL0501.jpg/info.json`,
        headerText: '<h5>Sonia Ben Saleme, Tunisia</h5>',
        bodyText: `<i>Sugar and Lemon, Artforness, France, 2020</i>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },

    {
        paintingId: 'ILL0601',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['ILL0601AR', 'ILL0601UK'],
        annotation_location: ANNOTATION_LOCATION.TOP_LEFT,
        annotation_location_vert_offset: 0.05,
    },
    {
        paintingId: 'ILL0601AR',
        videoId: null,
        videoURL: null,
        annotationTextAlignment: 'right',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ILL0601.jpg/info.json`,
        headerText: '<h5>رافايل معكرون،لبنان</h5>',
        bodyText: `<span dir="rtl"><i>جلاب طازج، مواقع التواصل الاجتماعي، لبنان، ٢٠٢٠</i></span>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    {
        paintingId: 'ILL0601UK',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ILL0601.jpg/info.json`,
        headerText: '<h5>Raphaelle Macaron, Lebanon</h5>',
        bodyText: `<i>Fresh Jallab, Social Media, Lebanon, 2020</i>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },

    {
        paintingId: 'ILL0701',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['ILL0701AR', 'ILL0701UK'],
        annotation_location: ANNOTATION_LOCATION.TOP_LEFT,
        annotation_location_vert_offset: 0.05,
        annotation_location_horiz_offset: -0.01,
    },
    {
        paintingId: 'ILL0701AR',
        videoId: null,
        videoURL: null,
        annotationTextAlignment: 'right',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ILL0701.jpg/info.json`,
        headerText: '<h5>حنان قاعي وكريستيان سركيس، لبنان</h5>',
        bodyText: `<span dir="rtl"><i>تكريم سارة حجازي، مواقع التواصل الاجتماعي، لبنان، ٢٠٢٠</i></span>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    {
        paintingId: 'ILL0701UK',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ILL0701.jpg/info.json`,
        headerText: '<h5>Hanane Kai & Kristyan Sarkis, Lebanon</h5>',
        bodyText: `<i>Hanane Kai & Kristyan Sarkis, Lebanon</i>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },

    {
        paintingId: 'ILL0801',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['ILL0801AR', 'ILL0801UK'],
    },
    {
        paintingId: 'ILL0801AR',
        videoId: null,
        videoURL: null,
        annotationTextAlignment: 'right',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ILL0801.jpg/info.json`,
        headerText: '<h5>كارلا حبيب، لبنان</h5>',
        bodyText: `<span dir="rtl"><i>ثوار ١٧ تشرين ٢،مجموعة زيز، لبنان، ٢٠٢٠</i></span>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    {
        paintingId: 'ILL0801UK',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ILL0801.jpg/info.json`,
        headerText: '<h5>Carla Habib, Lebanon</h5>',
        bodyText: `<i>Protestors of October 17 | 2, Zeez Collective, Lebanon, 2020</i>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    /* Wall 4: Graphic Illustartion */


    /* Wall 5: Children's Book Illustration */
    {
        paintingId: 'CHI0102',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['CHI0101AR', 'CHI0101UK'],
    },
    {
        paintingId: 'CHI0101AR',
        videoId: null,
        videoURL: null,
        annotationTextAlignment: 'right',
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CHI0101a.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0103.jpg/info.json`],
        headerText: `<h5>ديالا برصلي، سوريا</h5>`,
        bodyText: `<span dir="rtl"><i>الفائزة في فئة رسوم كتب الأطفال<br>الطائرة الورقية الجيدة، تيم كونينغهام، الولايات المتحدة الأميركية، ٢.١٩</i>تأمل ديالا برصلي أن يبقى عملها البصري شاهدًا على الأحداث التاريخية التي تكشّفت حولها والقضايا الاجتماعية التي وجّهت صلب أعمالها. مواضيع ثابتة تكرّرت في جميع مشاريعها ألا وهي العدالة الاجتماعية والحرية للشعب السوري والرغبة بشكل خاص في إعلاء صوت الأطفال الذين لا صوت لهم والأكثر ضعفاً بين أولئك الذين تم استهدافهم في الأزمة السورية الحالية. ولدت ديالا في الكويت لأبوين سوريين في عام 1980. نشأت في دمشق واستقرت فيها حتى بدء الانتفاضة. هربت مع جحافل الفنانين الآخرين إلى بلدان مختلفة إلى أن حصلت على حق اللجوء في فرنسا حيث واصلت العمل على مشاريعها لحسابها الخاص. بدأت ديالا كرسامة تحريك في قناة "سبايس تون" السورية في عام 2001، حيث تلقت تدريبها الأول وسرعان ما باشرت العمل كفنانة تخطيط لمسلسلات الرسوم المتحركة الناشئة. بعدها، اتسعت مسيرتها المهنية لتشمل مجموعة متنوعة من الوسائط والقدرات، بما فيها التصميم والرسوم المتحركة والفن التصوّري والرسم والشرائط المصورة وتصميم الشخصيات. في 2014 أطلقت مبادرتها الخاصة برسم جداريات في مخيمات اللاجئين ومراكز التعليم البديل بين لبنان وتركيا لتشجيع الأطفال على العودة إلى المدرسة بعد انقطاع سنوات بسبب الحرب. في موازاة ذلك، كانت تنظم ورش عمل فنية للأطفال والكبار لمساعدتهم على التعبير عن أنفسهم. كما عملت مؤخرًا على مواضيع الصحّة النفسية مثل حالات اضطراب ما بعد الصدمة. وتسلط الضوء حاليًا على الوضع التعليمي للأطفال السوريين واللاجئين بشكل عام.</span>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    {
        paintingId: 'CHI0101UK',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CHI0101a.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0103.jpg/info.json`],
        headerText: `<h5>Diala Brisly, Syria</h5>`,
        bodyText: `<i>Children's Book Illustration Winner<br>The Good Kite, Tim Cunningham, United States of America, 2019</i><br><br>Born in Kuwait to Syrian parents in 1980, Diala grew up in Damascus and was based there until the uprisings. She fled with legions of other artists fleeing to different countries until she got asylum in France, where she continued working on her projects as a freelancer. Diala began as a cartoonist at the Syrian-based Spacetoon channel in 2001, where she received her first training and soon began as a layout artist for the fledgling cartoon series. Since then, her career has spanned various mediums and capacities, including layout design, animation, concept art, painting, comic books, and character design. In 2014, she started her initiative making murals in the refugee camps and alternative education centers between Lebanon and Turkey to encourage kids to go back to school after skipping a few years because of the war. In parallel, she was doing art workshops for kids and adults to help them express themselves. She worked recently on well-being and psychological themes like post-trauma situations. Now she is spotting the light on the education situation of Syrian kids and refugees in general.   Diala Brisly hopes that her visual work would stand as a testament to the historical events that have unfolded around her and the social issues that have driven her work's heart. Several themes have consistently run through all her projects; social justice, freedom for the Syrian people, and a desire to give a voice to children, the most voiceless and most vulnerable among those targeted in Syria's current turmoil.`,
        // urlLink1Label: "",
        // urlLink1: '',
    },

    {
        paintingId: 'CHI0201',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['CHI0201AR', 'CHI0201UK'],
        annotation_location: ANNOTATION_LOCATION.CENTER_RIGHT,
    },
    {
        paintingId: 'CHI0201AR',
        videoId: null,
        videoURL: null,
        annotationTextAlignment: 'right',
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CHI0201.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0201a.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0201b.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0201c.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0202.jpg/info.json`],
        headerText: '<h5>ديالا زادة، سوريا</h5>',
        bodyText: `<span dir="rtl"><i>ذاكرة منصور، دار حكاياتي، المملكة المتحدة، ٢٠٢٠</i></span>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    {
        paintingId: 'CHI0201UK',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CHI0201.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0201a.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0201b.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0201c.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0202.jpg/info.json`],
        headerText: '<h5>Diyala Zada, Syria</h5>',
        bodyText: `<i>Mansour's Memory, Hikayati Publishers Limited, United Kingdom, 2020</i>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },

    {
        paintingId: 'CHI0302',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['CHI0302AR', 'CHI0302UK'],
    },
    {
        paintingId: 'CHI0302AR',
        videoId: null,
        videoURL: null,
        annotationTextAlignment: 'right',
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CHI0302.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0302a.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0302b.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0302c.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0301.jpg/info.json`],
        headerText: '<h5>عمر لافي، الأردن</h5>',
        bodyText: `<span dir="rtl"><i>منطق الطير، دار كتب نون: مؤسسة ناهد الشوا الثقافية، كندا ،٢٠١٩ </i></span>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    {
        paintingId: 'CHI0302UK',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CHI0302.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0302a.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0302b.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0302c.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0301.jpg/info.json`],
        headerText: '<h5>Omar Lafi, Jordan</h5>',
        bodyText: `<i>The Conference of the Birds, Noon Books Publishing House: Nahed<br>AlShawa Cultural Institution, Canada, 2019</i>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },

    {
        paintingId: 'CHI0401',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['CHI0401AR', 'CHI0401UK'],
    },
    {
        paintingId: 'CHI0401AR',
        videoId: null,
        videoURL: null,
        annotationTextAlignment: 'right',
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CHI0401.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0401a.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0401b.jpg/info.json`],
        headerText: '<h5>سهيلة خالد، مصر</h5>',
        bodyText: `<span dir="rtl"><i>كأس ماء، دار كتب نون: مؤسسة ناهد الشوا الثقافية، كندا، ٢٠١٩</i></span>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    {
        paintingId: 'CHI0401UK',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CHI0401.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0401a.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0401b.jpg/info.json`],
        headerText: '<h5>Sohila Khaled, Egypt</h5>',
        bodyText: `<i>Cup of Water, Noon Books Publishing House: Nahed AlShawa Cultural Institution, Canada, 2019</i>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },

    {
        paintingId: 'CHI0501',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['CHI0501AR', 'CHI0501UK'],
    },
    {
        paintingId: 'CHI0501AR',
        videoId: null,
        videoURL: null,
        annotationTextAlignment: 'right',
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CHI0501.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0501a.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0501b.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0501c.jpg/info.json`],
        headerText: '<h5>حنان قاعي، لبنان</h5>',
        bodyText: `<span dir="rtl"><i>سأعيش مطمئنًا، دار جبل عمان، الأردن، ٢٠٢٠</i></span>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    {
        paintingId: 'CHI0501UK',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CHI0501.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0501a.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0501b.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0501c.jpg/info.json`],
        headerText: '<h5>Hanane Kai, Lebanon</h5>',
        bodyText: `<i>I Will Live in Peace, Jabal Amman Publishing House, Jordan, 2020</i>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },

    {
        paintingId: 'CHI0601',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['CHI0601AR', 'CHI0601UK'],
    },
    {
        paintingId: 'CHI0601AR',
        videoId: null,
        videoURL: null,
        annotationTextAlignment: 'right',
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CHI0601.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0601a.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0601b.jpg/info.json`],
        headerText: '<h5>فادي فاضل، سوريا</h5>',
        bodyText: `<span dir="rtl"><i>أترى؟، دار كلمات، الإمارات العربية المتحدة، ٢٠١٨</i></span>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    {
        paintingId: 'CHI0601UK',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CHI0601.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0601a.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0601b.jpg/info.json`],
        headerText: '<h5>Fadi Fadel, Syria</h5>',
        bodyText: `<i>Do you see?, Kalimat Publishing House, United Arab Emirates, 2018</i>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },

    {
        paintingId: 'CHI0701',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['CHI0701AR', 'CHI0701UK'],
    },
    {
        paintingId: 'CHI0701AR',
        videoId: null,
        videoURL: null,
        annotationTextAlignment: 'right',
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CHI0701.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0701a.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0701b.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0701c.jpg/info.json`],
        headerText: '<h5>بسمة حسام، مصر</h5>',
        bodyText: `<span dir="rtl"><i>أبي في العمل و أمي في السماء، دار أشجار، الإمارات العربية المتحدة، ٢٠٢٠</i></span>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    {
        paintingId: 'CHI0701UK',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CHI0701.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0701a.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0701b.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0701c.jpg/info.json`],
        headerText: '<h5>Basma Hosam, Egypt</h5>',
        bodyText: `<i>My dad is at Work and My Mom is in the Sky, Ashjar Publishing House, United Arab Emirates, 2020</i>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },

    {
        paintingId: 'CHI0801',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['CHI0801AR', 'CHI0801UK'],
    },
    {
        paintingId: 'CHI0801AR',
        videoId: null,
        videoURL: null,
        annotationTextAlignment: 'right',
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CHI0801.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0801a.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0801b.jpg/info.json`],
        headerText: '<h5>أماني يوسف، الأردن</h5>',
        bodyText: `<span dir="rtl"><i>أحمر أزرق أصفر، دار نهضة مصر، مصر، ٢٠٢٠</i></span>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    {
        paintingId: 'CHI0801UK',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CHI0801.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0801a.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CHI0801b.jpg/info.json`],
        headerText: '<h5>Amani Yousef, Jordan</h5>',
        bodyText: `<i>Red Blue Yellow, Nahda Egyptian Publishing House, Egypt, 2020</i>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    /* Wall 5: Children's Book Illustration */


    /* Wall 6: Lifetime Achievement Award */
    {
        paintingId: 'LIF0501',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LIF0501AR', 'LIF0501UK'],
        annotation_location: ANNOTATION_LOCATION.BOTTOM_RIGHT,
    },
    {
        paintingId: 'LIF0501AR',
        videoId: null,
        videoURL: null,
        annotationTextAlignment: 'right',
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LIF0501.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LIF0201.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LIF0301.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LIF0401.jpg/info.json`],
        headerText: `<h5>إبراهيم لمهادي، المغرب</h5>`,
        bodyText: `<span dir="rtl"><i>الفائز في جائزة إنجازات العمر الفخرية</i><br><br>الفنان ابراهيم لمهادي -المزداد عام 1941 بمدينة الدار البيضاء- تجربة إبداعية كبيرة إذ يُعَدُّ واحداً من الفنانين القلائل الذين أسَّسوا للبداية الفعلية للرسم الكاريكاتيري في المغرب مع ما رافق ذلك من حذر شديد على مستوى الإبداع والنشر في لحظات مفصلية صعبة عاشها المغاربة خلال سنوات الجمر والرصاص. وقد تمكن من نشر رسوماته الساخرة في بعض المنابر الإعلامية العالمية، التي نال بفضلها جوائز دولية، أهمها جائزة تحفيزية عن تناوله لموضوع حرب فيتنام وما ترتب عنها من ويلات، فضلاً عن مشاركته في معارض فنية متنوِّعة.انخرط الرسام لمهادي باكراً في مجال الكاريكاتير وسط ظروف سياسية واجتماعية حسَّاسة لم تكن سهلة عاشها المغرب خلال ستينيات وسبعينيات القرن الماضي، ساهمت في حظره ومصادرته ومنعه لاسيما في اتصاله بالصحافة المكتوبة تجنُّباً لأي دور تحريضي أو توجيهي قد يلعبه.في هذه الظروف العصيبة، تفجَّرت موهبة هذا الرسام الرَّائد بعد أن أوجد لها المساحات الملائمة للإبداع والتعبير الحر، محتمياً في تجربته التعليمية وبخبرته الفنية الوافية.    في هذه الظروف العصيبة، تفجَّرت موهبة هذا الرسام الرَّائد بعد أن أوجد لها المساحات الملائمة للإبداع والتعبير الحر، محتمياً في تجربته التعليمية وبخبرته الفنية الوافية. كما كان من أبرز الرسامين المغاربة إلى جانب الرَّاحل العربي بلقاضي، محمد الفيلالي، العربي الصبان، بوهالي حميد، محمد عليوات (حمودة)، محمد ليتيم، عبد السلام المريني وغيرهم من الرسامين المؤسِّسين الذين انتبهوا بشكل مبكر لوضعية فن الكاريكاتير الذي ظلَّ في المغرب معرَّضاً للتضييق والخناق بسبب انعدام حرية التعبير لسنوات وظل أيضاً غير معترف به داخل النسيج الثقافي الوطني ولم يكن يهتم به آنذاك سوى ممارسيه والقليل من المثقفين، الأمر الذي أجَّج في أكثر من مناسبة أصواتاً غيورة دعت إلى إعادة الاعتبار لهذا الفن الإنساني الرَّاقي ودعمه  وتشجيع فنانيه وممارسيه. - ابراهيم الحَيْسن، ناقد تشكيلي من المغرب</span>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    {
        paintingId: 'LIF0501UK',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LIF0501.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LIF0201.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LIF0301.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LIF0401.jpg/info.json`],
        headerText: `<h5>Ibrahim L'Mhadi, Morocco</h5>`,
        bodyText: `<i>Lifetime Achievement Award Honorary Winner</i><br><br>Artist Ibrahim L'Mhadi, born in Casablanca in 1941, is considered one of the few artists that laid the actual groundwork for cartoons in Morocco. He managed to do so despite the extreme caution and reservation in terms of production and publishing during the difficult times that Moroccans endured during the Years of Lead. L'Mhadi managed to publish his satirical drawings in a number of international media outlets, which won him several international awards. Among these was a motivational award for choosing to depict the Vietnam War and its tragedies.<br>L'Mhadi was one of the first people who began to experiment with cartoons amid the sensitive political and social circumstances that Morocco witnessed in the 1960s and 1970s. At that time, cartoons were confiscated and prohibited, especially in print media; authorities feared they would incite or inspire dissent.<br>Amid those trying circumstances, L'Mhadi discovered his talent after finding adequate spaces for free expression and unleashing his creative potential. He took refuge in his educational experience and his broad artistic expertise. L'Mhadi was one of the most prominent Moroccan artists, alongside the late Alarabi Balqadi, Mohammad al-Filali, Alarabi Alsaban, Bouhali Hmayed, Mohammed Alyawat (Hammudah), Mohamad al-Yatim, Abdul Salam al-Marini and many others who laid the foundations of cartoons in Morocco; they noticed, early on, the important role this art form could play. . - Ibrahim AlHaysan,Moroccan Visual Art Critic`,
        // urlLink1Label: "",
        // urlLink1: '',
    },

    {
        paintingId: 'LIF0601',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LIF0601AR', 'LIF0601UK'],
    },
    {
        paintingId: 'LIF0601AR',
        videoId: null,
        videoURL: null,
        annotationTextAlignment: 'right',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LIF0601.jpg/info.json`,
        headerText: `<h5>إبراهيم لمهادي، المغرب</h5>`,
        bodyText: `<span dir="rtl"><i>جائزة إنجازات العمر</i><br><br>الفنان ابراهيم لمهادي -المزداد عام 1941 بمدينة الدار البيضاء- تجربة إبداعية كبيرة إذ يُعَدُّ واحداً من الفنانين القلائل الذين أسَّسوا للبداية الفعلية للرسم الكاريكاتيري في المغرب مع ما رافق ذلك من حذر شديد على مستوى الإبداع والنشر في لحظات مفصلية صعبة عاشها المغاربة خلال سنوات الجمر والرصاص. وقد تمكن من نشر رسوماته الساخرة في بعض المنابر الإعلامية العالمية، التي نال بفضلها جوائز دولية، أهمها جائزة تحفيزية عن تناوله لموضوع حرب فيتنام وما ترتب عنها من ويلات، فضلاً عن مشاركته في معارض فنية متنوِّعة.انخرط الرسام لمهادي باكراً في مجال الكاريكاتير وسط ظروف سياسية واجتماعية حسَّاسة لم تكن سهلة عاشها المغرب خلال ستينيات وسبعينيات القرن الماضي، ساهمت في حظره ومصادرته ومنعه لاسيما في اتصاله بالصحافة المكتوبة تجنُّباً لأي دور تحريضي أو توجيهي قد يلعبه.في هذه الظروف العصيبة، تفجَّرت موهبة هذا الرسام الرَّائد بعد أن أوجد لها المساحات الملائمة للإبداع والتعبير الحر، محتمياً في تجربته التعليمية وبخبرته الفنية الوافية.    في هذه الظروف العصيبة، تفجَّرت موهبة هذا الرسام الرَّائد بعد أن أوجد لها المساحات الملائمة للإبداع والتعبير الحر، محتمياً في تجربته التعليمية وبخبرته الفنية الوافية. كما كان من أبرز الرسامين المغاربة إلى جانب الرَّاحل العربي بلقاضي، محمد الفيلالي، العربي الصبان، بوهالي حميد، محمد عليوات (حمودة)، محمد ليتيم، عبد السلام المريني وغيرهم من الرسامين المؤسِّسين الذين انتبهوا بشكل مبكر لوضعية فن الكاريكاتير الذي ظلَّ في المغرب معرَّضاً للتضييق والخناق بسبب انعدام حرية التعبير لسنوات وظل أيضاً غير معترف به داخل النسيج الثقافي الوطني ولم يكن يهتم به آنذاك سوى ممارسيه والقليل من المثقفين، الأمر الذي أجَّج في أكثر من مناسبة أصواتاً غيورة دعت إلى إعادة الاعتبار لهذا الفن الإنساني الرَّاقي ودعمه  وتشجيع فنانيه وممارسيه. - ابراهيم الحَيْسن، ناقد تشكيلي من المغرب</span>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    {
        paintingId: 'LIF0601UK',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LIF0601.jpg/info.json`,
        headerText: `<h5>Ibrahim L'Mhadi, Morocco</h5>`,
        bodyText: `<i>Lifetime Achievement Award Honorary Winner</i><br><br>Artist Ibrahim L'Mhadi, born in Casablanca in 1941, is considered one of the few artists that laid the actual groundwork for cartoons in Morocco. He managed to do so despite the extreme caution and reservation in terms of production and publishing during the difficult times that Moroccans endured during the Years of Lead. L'Mhadi managed to publish his satirical drawings in a number of international media outlets, which won him several international awards. Among these was a motivational award for choosing to depict the Vietnam War and its tragedies.<br>L'Mhadi was one of the first people who began to experiment with cartoons amid the sensitive political and social circumstances that Morocco witnessed in the 1960s and 1970s. At that time, cartoons were confiscated and prohibited, especially in print media; authorities feared they would incite or inspire dissent.<br>Amid those trying circumstances, L'Mhadi discovered his talent after finding adequate spaces for free expression and unleashing his creative potential. He took refuge in his educational experience and his broad artistic expertise. L'Mhadi was one of the most prominent Moroccan artists, alongside the late Alarabi Balqadi, Mohammad al-Filali, Alarabi Alsaban, Bouhali Hmayed, Mohammed Alyawat (Hammudah), Mohamad al-Yatim, Abdul Salam al-Marini and many others who laid the foundations of cartoons in Morocco; they noticed, early on, the important role this art form could play. . - Ibrahim AlHaysan,Moroccan Visual Art Critic`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    /* Wall 6: Lifetime Achievement Award */


    /* Wall 7: Comics Guardian Award */
    {
        paintingId: 'CGA0301',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['CGA0301AR', 'CGA0301UK'],
    },
    {
        paintingId: 'CGA0301AR',
        videoId: null,
        videoURL: null,
        annotationTextAlignment: 'right',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}CGA0301.jpg/info.json`,
        headerText: `<h5>الأكاديمية اللبنانية للفنون الجميلة</h5>`,
        bodyText: `<span dir="rtl"><i>الفائز في جائزة  راعي الشريط المصور الفخرية <br> برنامج الماجستير في الرسم التصويري والقصص المصورة في الأكاديمية اللبنانية للفنون الجميلة</i><br><br>تأسّسَ فرعُ الرسم التصويري- القصص المصوّرة الرياديّ في مدرسة الفنّ الغرافيكي في الأكاديمية اللبنانيّة للفنون الجميلة (ALBA) على مرحلتين ما بين العامين١٩٩٧ و٢٠٠٠. فكانت المرّة الأولى التي يّقدَم فيها خيارٌ أكاديمي إستثنائيّ لطلبة الماستر الراغبين في التعمّق باكتساب المهارات في هذا الاختصاص وتنفيذ مشروع دبلوم يكون عبارة عن كتاب قصص مصوّرة. وما لبث أن تحوّل هذا الخيارُ الأكاديميّ إلى برنامج شامل جرى إطلاقه في العام ٢٠٠٠.<br>حصلَ أوائل المتخرّجين في هذا البرنامج على شهادات الدبلوم في العام ٢٠٠٣. ومنذ ذلك التاريخ، منحت الأكاديمية اللبنانيّة للفنون الجميلة (ألبا) ١٠٣ شهادة إجازة و٤٧ شهادة ماستر في الرسم التصويريّ والقصص المصوّرة. وتبقى هذه الأكاديميّة لغاية يومنا هذا المؤسّسة التعليمية الوحيدة في المنطقة التي تقدِّمُ برنامجاً  شاملاً في هذين الاختصاصين.<br>يفتحُ هذا البرنامجُ المجالَ أمام الطلبة لتطوير مهاراتهم الفنيّة، والتمرّس في استخدام الأدوات الرقميّة والتقليديّة وإتقان الرموز السرديّة والتعبيريّة لرسوم الكاريكاتير والشرائط المصوّرة. أما أهميّة البرنامج الكبرى فتكمنُ في هدفه القائم على تطوير حبّ الاطلاع والتفكير النقدي والأبحاث وتعزيز اعتماد مقاربة تحليليّة وتأمّلية إزاءَ ما يحدثُ في  العالم.<br>يتّخذ منهاجُ العمل في البرنامج طابعاً تفاعليّاً في كافة الأوقات حتى ولو كان التعلّمُ عن بُعد... ويعملُ الطلبة بشكلٍ عام على مشاريع مرتبطة بمختلف تطبيقات الرسم التصويريّ التي تطاولُ إصدار النُسخ، والطباعة، والإعلان، والشرائط المصوّرة فضلاً عن السينوغرافيا وتصميم الشخصيّات. هذا ويتعاون طلبة الماستر مع زملائهم في الفروع الأخرى في الكليّة، وبخاصّةٍ مع طلبة اختصاص الرسم المتحرّك والنشر بالوسائل المتعدّدة.<br>تتيحُ هذه المروحة الواسعة من الأهداف التعلميّة للطلبة اكتسابَ الليونة والمرونة وتعدّدية المهارات التي سيحتاجون التسلّحَ بها في سبيل تحقيق الاندماج المهني. هذا ويشهد برنامجُ الماستر المتميّز بمطواعيّته وبتداخل التخصّصات وحقول الدراسة فيه، تطوّراً مستمرّاً ليتأقلمَ مع المتطلّبات المتغيّرة في واقع المهنة. وها هم خرّيجو الرسم التصويري من الأكاديمية اللبنانيّة للفنون الجميلة (ألبا) يغادرونها متسلّحين بالمخزون الأكاديميّ الأساسيّ الذي يخوّلهم خوضَ غمار كافة المجالات التي ترتبط أو يُرتقب ارتباطها باختصاصهم.   </span>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    {
        paintingId: 'CGA0301UK',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}CGA0301.jpg/info.json`,
        headerText: '<h5>ALBA,Lebanon</h5>',
        bodyText: `<span dir="rtl"><i>Comics Guardian Award Honorary Winner<br>Master's program in Comics and Illustration at the Lebanese Academy of Arts (ALBA)</i><br><br>"The pioneer illustration and comics branch of the School of Graphic Arts at Alba was launched in two stages, between 1997 and 2000. A special track was first offered to Master’s students willing to deepen their know-how and complete a comic-book diploma. This option then developed into a comprehensive program launched in 2000, with the first graduates receiving their diplomas in 2003. Since then, Alba has issued 103 Bachelor of Arts degrees in Illustration and Bande Dessinée (Comics), and 47 Masters degrees. The School, to date, remains the only institution in the region that offers a complete program in these two disciplines.<br>The program allows students to develop the discipline’s technical know-how, to handle digital and traditional tools, and to master the narrative and graphic codes of comic strips. Most importantly, the program aims at developing curiosity, critical thinking, research, and a reflexive and analytical approach of the world.<br>Globally, students work on projects related to the different applications of illustration: publishing, press, advertising, and comic strips, as well as scenography and character design. Masters students The program itself is interdisciplinary and agile; it evolves and adapts to the changing needs of the professional reality. Alba Illustration graduates leave the school with the necessary experience and skills to assimilate into all the fields their degree and their discipline is linked to."</span>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },

    {
        paintingId: 'CGA0501',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['CGA0501AR', 'CGA0501UK'],
    },
    {
        paintingId: 'CGA0501AR',
        videoId: null,
        videoURL: null,
        annotationTextAlignment: 'right',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}CGA0501.jpg/info.json`,
        headerText: `<h5>الأكاديمية اللبنانية للفنون الجميلة</h5>`,
        bodyText: `<span dir="rtl"><i>الفائز في جائزة  راعي الشريط المصور الفخرية <br> برنامج الماجستير في الرسم التصويري والقصص المصورة في الأكاديمية اللبنانية للفنون الجميلة</i><br><br>تأسّسَ فرعُ الرسم التصويري- القصص المصوّرة الرياديّ في مدرسة الفنّ الغرافيكي في الأكاديمية اللبنانيّة للفنون الجميلة (ALBA) على مرحلتين ما بين العامين١٩٩٧ و٢٠٠٠. فكانت المرّة الأولى التي يّقدَم فيها خيارٌ أكاديمي إستثنائيّ لطلبة الماستر الراغبين في التعمّق باكتساب المهارات في هذا الاختصاص وتنفيذ مشروع دبلوم يكون عبارة عن كتاب قصص مصوّرة. وما لبث أن تحوّل هذا الخيارُ الأكاديميّ إلى برنامج شامل جرى إطلاقه في العام ٢٠٠٠.<br>حصلَ أوائل المتخرّجين في هذا البرنامج على شهادات الدبلوم في العام ٢٠٠٣. ومنذ ذلك التاريخ، منحت الأكاديمية اللبنانيّة للفنون الجميلة (ألبا) ١٠٣ شهادة إجازة و٤٧ شهادة ماستر في الرسم التصويريّ والقصص المصوّرة. وتبقى هذه الأكاديميّة لغاية يومنا هذا المؤسّسة التعليمية الوحيدة في المنطقة التي تقدِّمُ برنامجاً  شاملاً في هذين الاختصاصين.<br>يفتحُ هذا البرنامجُ المجالَ أمام الطلبة لتطوير مهاراتهم الفنيّة، والتمرّس في استخدام الأدوات الرقميّة والتقليديّة وإتقان الرموز السرديّة والتعبيريّة لرسوم الكاريكاتير والشرائط المصوّرة. أما أهميّة البرنامج الكبرى فتكمنُ في هدفه القائم على تطوير حبّ الاطلاع والتفكير النقدي والأبحاث وتعزيز اعتماد مقاربة تحليليّة وتأمّلية إزاءَ ما يحدثُ في  العالم.<br>يتّخذ منهاجُ العمل في البرنامج طابعاً تفاعليّاً في كافة الأوقات حتى ولو كان التعلّمُ عن بُعد... ويعملُ الطلبة بشكلٍ عام على مشاريع مرتبطة بمختلف تطبيقات الرسم التصويريّ التي تطاولُ إصدار النُسخ، والطباعة، والإعلان، والشرائط المصوّرة فضلاً عن السينوغرافيا وتصميم الشخصيّات. هذا ويتعاون طلبة الماستر مع زملائهم في الفروع الأخرى في الكليّة، وبخاصّةٍ مع طلبة اختصاص الرسم المتحرّك والنشر بالوسائل المتعدّدة.<br>تتيحُ هذه المروحة الواسعة من الأهداف التعلميّة للطلبة اكتسابَ الليونة والمرونة وتعدّدية المهارات التي سيحتاجون التسلّحَ بها في سبيل تحقيق الاندماج المهني. هذا ويشهد برنامجُ الماستر المتميّز بمطواعيّته وبتداخل التخصّصات وحقول الدراسة فيه، تطوّراً مستمرّاً ليتأقلمَ مع المتطلّبات المتغيّرة في واقع المهنة. وها هم خرّيجو الرسم التصويري من الأكاديمية اللبنانيّة للفنون الجميلة (ألبا) يغادرونها متسلّحين بالمخزون الأكاديميّ الأساسيّ الذي يخوّلهم خوضَ غمار كافة المجالات التي ترتبط أو يُرتقب ارتباطها باختصاصهم.   </span>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    {
        paintingId: 'CGA0501UK',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}CGA0501.jpg/info.json`,
        headerText: '<h5>ALBA, Lebanon</h5>',
        bodyText: `<span dir="rtl"><i>Comics Guardian Award Honorary Winner<br>Master's program in Comics and Illustration at the Lebanese Academy of Arts (ALBA)</i><br><br>"The pioneer illustration and comics branch of the School of Graphic Arts at Alba was launched in two stages, between 1997 and 2000. A special track was first offered to Master’s students willing to deepen their know-how and complete a comic-book diploma. This option then developed into a comprehensive program launched in 2000, with the first graduates receiving their diplomas in 2003. Since then, Alba has issued 103 Bachelor of Arts degrees in Illustration and Bande Dessinée (Comics), and 47 Masters degrees. The School, to date, remains the only institution in the region that offers a complete program in these two disciplines.<br>The program allows students to develop the discipline’s technical know-how, to handle digital and traditional tools, and to master the narrative and graphic codes of comic strips. Most importantly, the program aims at developing curiosity, critical thinking, research, and a reflexive and analytical approach of the world.<br>Globally, students work on projects related to the different applications of illustration: publishing, press, advertising, and comic strips, as well as scenography and character design. Masters students The program itself is interdisciplinary and agile; it evolves and adapts to the changing needs of the professional reality. Alba Illustration graduates leave the school with the necessary experience and skills to assimilate into all the fields their degree and their discipline is linked to."</span>`,
        // urlLink1Label: "",
        // urlLink1: '',
    },
    /* Wall 7: Comics Guardian Award */



    // {
    //     paintingId: '',
    //     videoId: null,
    //     videoURL: null,
    //     hasCarouselAsParent: 'Y',
    //     carouselAnnotationSiblings: ['', ''],
    // },
    // {
    //     paintingId: '',
    //     videoId: null,
    //     videoURL: null,
    //     annotationTextAlignment: 'right',
    //     iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
    //     headerText: '<h5></h5>',
    //     bodyText: '',
    //     // urlLink1Label: "",
    //     // urlLink1: '',
    // },
    // {
    //     paintingId: '',
    //     videoId: null,
    //     videoURL: null,
    //     iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
    //     headerText: '<h5></h5>',
    //     bodyText: '',
    //     // urlLink1Label: "",
    //     // urlLink1: '',
    // },
    //
    {
        paintingId: '',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['', ''],
    },
    {
        paintingId: '',
        videoId: null,
        videoURL: null,
        annotationTextAlignment: 'right',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
        headerText: '<h5></h5>',
        bodyText: '',
        // urlLink1Label: "",
        // urlLink1: '',
    },
    {
        paintingId: '',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
        headerText: '<h5></h5>',
        bodyText: '',
        // urlLink1Label: "",
        // urlLink1: '',
    },
];

export {AnnotationsDB};
